import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';

import { ExpandableMenuItem } from 'components';
import {
    selectPreferredCurrency,
    selectShowCurrencySelection
} from 'tradera-state/multi-currency';
import {
    selectPreferredLanguage,
    selectShouldAlwaysDisplayInMenu
} from 'tradera-state/language';
import { LocalizationMenu } from 'static/script/components/localization/localization-menu';
import LocationIcon from '@tradera/blueprint/theme/icons2/location.svg?jsx';
import { BREAKPOINT_SIZES, BREAKPOINTS } from 'tradera-constants/breakpoints';
import { selectShowRegionSelection } from 'tradera-state/shipping-region/selectors';
import { useTranslator } from 'tradera-lang';

export const LocalizationMenuItem = ({
    onToggle,
    preferredCurrency,
    showCurrencySelection,
    preferredLanguage,
    shouldAlwaysDisplayInMenu,
    showRegionSelection
}) => {
    const { t } = useTranslator();
    const onOpen = useCallback(() => onToggle('Open - Localization'), [
        onToggle
    ]);
    const onClose = useCallback(() => onToggle('Close - Localization'), [
        onToggle
    ]);

    const mediaQuery = shouldAlwaysDisplayInMenu
        ? { minWidth: BREAKPOINT_SIZES[BREAKPOINTS.XS].min }
        : { maxWidth: BREAKPOINT_SIZES[BREAKPOINTS.MD].max };

    return (
        <MediaQuery {...mediaQuery}>
            <ExpandableMenuItem
                label={
                    showCurrencySelection
                        ? `${preferredLanguage.languageCodeIso3} / ${preferredCurrency.shortName}`
                        : t('siteheader_language', {
                              language: preferredLanguage.languageCodeIso3
                          })
                }
                className="site-dropdown__item-with-icon text-inter-medium site-dropdown__localization-menu-item"
                border
                icon={<LocationIcon className="icon" />}
                onOpen={onOpen}
                onClose={onClose}>
                <LocalizationMenu
                    idPrefix="profile-menu"
                    showCurrencySelection={showCurrencySelection}
                    showRegionSelection={showRegionSelection || false}
                />
            </ExpandableMenuItem>
        </MediaQuery>
    );
};

LocalizationMenuItem.propTypes = {
    onToggle: PropTypes.func.isRequired,
    preferredCurrency: PropTypes.object,
    showCurrencySelection: PropTypes.bool.isRequired,
    preferredLanguage: PropTypes.object
};

const mapStateToProps = state => ({
    preferredCurrency: selectPreferredCurrency(state),
    showCurrencySelection: selectShowCurrencySelection(state),
    preferredLanguage: selectPreferredLanguage(state),
    shouldAlwaysDisplayInMenu: selectShouldAlwaysDisplayInMenu(state),
    showRegionSelection: selectShowRegionSelection(state)
});

export const ConnectedLocalizationMenuItem = connect(mapStateToProps)(
    LocalizationMenuItem
);
